import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { filter } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Details } from 'src/interfaces/details.model';
import { SheetDirective } from 'src/app/directives/sheet.directive';

@Component({
    selector: 'app-menu-footer-dialog',
    templateUrl: './menu-footer-dialog.component.html',
    styleUrls: ['./menu-footer-dialog.component.css'],
    standalone: false
})
export class MenuFooterDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<MenuFooterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Details
  ) {
    this.details = this.data;

    // Затемнение и Esc закрывают окно с анимацией, а не мгновенно
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => this.close());
    this.dialogRef.keydownEvents()
      .pipe(filter((event) => event.key === 'Escape'))
      .subscribe(() => this.close());
  }

  @ViewChild('scrollContent') scrollContent!: ElementRef;
  @ViewChild(SheetDirective) sheet!: SheetDirective;

  details: Details;

  /** Окно уезжает вниз, затем диалог закрывается (onSheetClosed) */
  close(): void {
    this.sheet.dismiss();
  }

  onSheetClosed(): void {
    this.dialogRef.close();
  }
}
